import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-localiza-placa',
  templateUrl: './consulta-localiza-placa.component.html',
  styleUrls: ['./consulta-localiza-placa.component.scss']
})
export class ConsultaLocalizaPlacaComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {

  }

}
